import walidacjaRoku from '@components/form/validation/field/rokModelowy'
import validated from '@components/form/validation/validated'

export default validated({
    t: 'Rok modelowy',
    name: 'rok-modelowy',
    type: 'number',

}, walidacjaRoku)